<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    v-if="!disabled"
  >
    <template v-slot:activator="{ on }" v-if="!hidden">
      <v-btn v-on="on" color="primary" dark>{{ ctaResult }}</v-btn>
    </template>
    <v-card class="elevation-16 mx-auto">
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Seu desempenho</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items v-if="!hideReviewBtn">
          <v-btn dark text @click="dialog = false">
            Revisar
            <v-icon right dark>video_library</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <div class="text-center my-5 result-percent">
          <h1>{{ this.percent }}%</h1>
        </div>
        <div class="text-center my-2">
          <h4>{{ score }} acerto(s) de {{ totalQuestions }} possíveis</h4>
        </div>
        <div class="text-center my-2">
          <v-rating
            v-model="rating"
            color="yellow darken-3"
            background-color="grey darken-1"
            empty-icon="$vuetify.icons.ratingFull"
            half-increments
            hover
            readonly
          ></v-rating>
          <performance-radar-chart v-if="!disabled" :mock-log-id="mockLogId">
          </performance-radar-chart>
        </div>
        <div v-if="reviewQuestions && review">
          <question-review :review="review" />
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import PerformanceRadarChart from "../widgets/chart/PerformanceRadarChart";
import QuestionReview from "./QuestionReview";
export default {
  components: { PerformanceRadarChart, QuestionReview },
  data() {
    return {
      dialog: true,
    };
  },
  computed: {
    rating() {
      return (this.percent / 100) * 5;
    },
    percent() {
      if (this.score === 0) return 0;
      return Math.round((this.score / this.totalQuestions) * 100);
    },
    ctaResult() {
      if (this.score === 0) return "Resultado";
      return "Resultado (" + this.percent + "%)";
    },
  },
  props: {
    totalQuestions: null,
    score: null,
    disabled: true,
    mockLogId: null,
    reviewQuestions: false,
    hidden: false,
    review: null,
    hideReviewBtn: false,
  },
  created() {},
  methods: {
    isCorrect(option) {
      if (this.disabled && this.question.correct_answer) {
        return this.question.correct_answer === option;
      }
    },
  },
};
</script>

<style scoped>
.result-percent {
  padding-top: 12px;
  padding-bottom: 6px;
}
.v-card__text {
  line-height: auto;
}

.text-center {
  text-align: center;
}

.correct {
  border-style: dotted;
  color: green;
  border-color: green;
  padding: 5px;
}

.statement {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
